import RequestQueueManager from 'components/layout_and_quote_builder/utils/RequestQueueManager.js';

// FRANK'S OWN REQUEST QUEUE, and why it is not the shared one.
//
// defaultRequestQueueManager is capped at window.RequestQueueManagerC (MANUFACTURING_COST_CALCULATOR_MAX_
// CONCURRENT, which is 1 in .env). That cap exists because each of those requests USED to be a full solve held
// open on a web thread, and running forty of them at once would have taken the site down with it.
//
// They are not that any more. A section's answers are computed on the manufacturing_cost_calculator queue
// (Frank::SectionAnswer) and these requests only ask whether one has landed yet -- a Redis read. Leaving them
// behind the old cap would be actively harmful: with a cap of one, the FIRST manufacturing line's whole poll
// loop would have to finish before the second one was even ASKED FOR, so the work would be handed to the
// workers one job at a time and scored exactly as serially as it used to be. The parallelism this change is for
// lives in the worker pool, and it can only be reached if the browser asks for every manufacturing line at
// once.
//
// So the cap here is simply "more than a section has". What actually limits things is the browser's own
// per-host connection limit on the way out and the queue's workers on the way back, both of which are real
// limits that do not need a third one in front of them.
export const SECTION_ANSWER_CONCURRENCY = 64;

// Kept apart from defaultRequestQueueManager for one more reason: that queue also drives the LEGACY
// Manufacturing Cost Calculator's progress bar, and the legacy page still makes the heavy kind of request. Its
// cap and its progress counts stay exactly as they are.
const sectionAnswerQueue = new RequestQueueManager(SECTION_ANSWER_CONCURRENCY);

export default sectionAnswerQueue;
